<app-grid-container class="appliance-details">
  <app-grid-row class="white-container">
    <app-grid-column>
      <app-grid-row>
        <app-grid-column>
          <app-progression-steps />

          <h1 class="appliance-details__title">
            {{ "APPLIANCE_DETAILS_PAGE_TITLE" | translate }}
          </h1>
        </app-grid-column>
      </app-grid-row>

      <app-grid-row>
        <app-grid-column [md]="6">
          <app-registered-appliance
            class="appliance-details__registered-appliance"
          />
          <app-appliance-details-form
            [selectedAppliances]="selectedAppliances()"
            class="appliance-details__form"
          />
        </app-grid-column>

        <app-grid-column
          [block]="'md'"
          [hidden]="'xs'"
          [md]="6"
          class="appliance-details-column--right"
        >
          <app-benefits-list-covered-items
            [benefitsListCoveredItems]="coveredItems()"
          />

          <app-benefits-list-not-covered-items
            [benefitsListNotCoveredItems]="notCoveredItems()"
            class="appliance-details__not-covered-items"
          />

          <app-benefits-list-additional-items
            [benefitsListAdditionalItems]="additionalItems()"
          />
        </app-grid-column>
      </app-grid-row>
    </app-grid-column>
  </app-grid-row>
</app-grid-container>
